import { useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import styled from "styled-components";
import { getAdaptiveFontSize } from "../../utils/styling.utils";
import { primarySleeperFirstNameSelector } from "../../redux/slices/mattressConfiguration";
import ResultTable from "../../navigation/MattressBuilder/common/ResultTable";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledContainer = styled.div`
  width: 85%;
  height: 65%;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 2%;
  padding-bottom: 2%;
  margin-top: 5%;
  margin-bottom: 5%;
  border-radius: 40px;
`;

const StyledTitle = styled.div`
  margin-bottom: 2vh;
`;

const StyledSubTitle = styled.div`
  font-weight: 600;
  margin-top: 1vh;
`;

const SummaryTable = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const primarySleeperFirstName = useSelector(primarySleeperFirstNameSelector);
  return (
    <StyledContainer style={{ backgroundColor: theme.COLORS.BLUE.lightBlue4 }}>
      <StyledTitle
        style={{
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: isMediumScreen
            ? getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 1.5,
              })
            : "1.2rem",
        }}
      >
        {t("Your Inputs:")}
      </StyledTitle>

      <ResultTable></ResultTable>

      <StyledSubTitle
        style={{
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: isMediumScreen
            ? getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 0.9,
              })
            : "0.8rem",
        }}
      >
        {`${t(
          "Sleep Experts are using the information you provided to personalize your evrbed."
        )}`}
      </StyledSubTitle>
    </StyledContainer>
  );
};

export default SummaryTable;
